import { store, setErrorBag, clearErrorBag } from 'modules';
import { ErrorType } from 'modules/redux/error/types';
import { serializeError } from 'serialize-error';

export function errorBag(error?: ErrorType, callback?: () => void): void {
  if (!error) {
    store.dispatch(clearErrorBag());
  } else {
    const serError = serializeError(error);
    store.dispatch(
      setErrorBag({
        error: serError,
        callback,
      }),
    );
  }
}
